<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="pack-result-sidebar items-no-padding"
    spacer
    v-model="isPromptActiveLocal"
  >
    <div class="flex items-center justify-between px-6 form-header">
      <h4>Résultat</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isPromptActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>

    <div class="p-6">
      <div class="vx-row">
        <div class="w-full px-2">
          <p class="info-text font-bold">INFORMATIONS</p>
        </div>
      </div>
      <div class="vx-row info-list mt-10">
        <div class="w-full px-2 info-line mt-4">
          <div class="info-section-left">Pack</div>
          <div class="info-section-right font-bold text-black">
            <small>{{ infos.title }}</small>
          </div>
        </div>
        <div class="w-full px-2 info-line mt-4">
          <div class="info-section-left">Composé le</div>
          <div class="info-section-right font-bold text-black">
            <small>{{ convertDate(infos.date) }}</small>
          </div>
        </div>
        <div class="w-full px-2 info-line mt-4">
          <div class="info-section-left">Durée de la compostion</div>
          <div class="info-section-right font-bold text-black">
            <small>{{ formatDuration(infos.time) }}</small>
          </div>
        </div>
        <div class="w-full px-2 info-line mt-4">
          <div class="info-section-left">Moyenne Obtenue</div>
          <div class="info-section-right font-bold text-black">
            <small>{{ infos.avg }} %</small>
          </div>
        </div>
      </div>
      <div class="vx-row download-section">
        <vs-button
          @click="downloadCertificate()"
          :color="$store.state.aa_button_color"
          type="filled"
          class="text-dark action-button w-full"
          >Télécharger le certificat</vs-button
        >
        <vs-button
          @click="downloadResults()"
          class="text-dark black-button w-full mt-4"
          >Télécharger les résultats</vs-button
        >
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import moment from "moment";

export default {
  name: "Otd2PackResultDetails",
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
    infos: { type: Object, required: true },
  },
  watch: {
    isPromptActive(val) {
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    async downloadCertificate() {
      try {
        this.$vs.loading();
        let response = await this.$http({
          url: "/trainings-pack/download-result-certificate",
          method: "POST",
          responseType: "blob",
          data: {
            result: this.infos.slug,
          },
        });

        if (response.data) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "certification-" + this.infos.title + ".pdf"
          );
          document.body.appendChild(link);
          link.click();

          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
        if (error.response.status === 401) {
          this.$vs.notify({
            title: "Erreur",
            text: "Votre session a expiré",
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right",
          });
          this.$router.push({ name: "login" });
        }
      }
    },
    async downloadResults() {
      try {
        this.$vs.loading();
        let response = await this.$http({
          url: "/trainings-pack/export-results",
          method: "POST",
          responseType: "blob",
          data: {
            result: this.infos.slug,
          },
        });

        if (response.data) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "results-" + this.infos.title + ".xlsx"
          );
          document.body.appendChild(link);
          link.click();

          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
        if (error.response.status === 401) {
          this.$vs.notify({
            title: "Erreur",
            text: "Votre session a expiré",
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right",
          });
          this.$router.push({ name: "login" });
        }
      }
    },
    convertDate(date) {
      moment.locale("fr");
      return moment(date).format("DD MMMM YYYY");
    },
    formatDuration(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " heure " : " heures ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " seconde" : " secondes") : "";
      return hDisplay + mDisplay + sDisplay;
    },
  },
};
</script>

<style lang="scss" scoped>
.action-button {
  background: #ffcc00 !important;
  border-radius: 25px;
}
.black-button {
  border: 1px solid black;
  background: transparent !important;
  color: black;
  border-radius: 25px;
}
.pack-result-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 1001;
  }

  ::v-deep .vs-sidebar {
    z-index: 10002;
    max-width: 361px;
  }

  ::v-deep .vs-sidebar .vs-sidebar--items {
    // overflow: scroll !important;
    height: 100%;
  }

  .form-header {
    background-color: #f8f8f8;
    height: 54px;
  }
}

.info-text {
  color: #b9b9c3;
}

.info-list {
  .info-line {
    display: flex;
    flex-direction: row;
    .info-section-left {
      width: 55%;
    }
    .info-section-right {
      width: 45%;
      text-align: right;
    }
  }
}

.download-section {
  margin-top: 80px;
}
</style>